import {LEGACY_TO_NEW_ROUTE_MAP} from './legacy-to-new-route-map'

const MODULE_LABELS = {
  '/events': 'Eventos',
  '/license-plate': 'LPR',
} as const

export type MigratedPortalModule = {
  id: string
  label: string
  legacyPath: string
  newPath: string
}

export const MIGRATED_PORTAL_MODULES: MigratedPortalModule[] = Object.entries(LEGACY_TO_NEW_ROUTE_MAP).map(([legacyPath, newPath]) => ({
  id: legacyPath.slice(1).replace(/-/g, '_'),
  label: MODULE_LABELS[legacyPath as keyof typeof MODULE_LABELS],
  legacyPath,
  newPath,
}))
